import axios from "axios";
import queryString from 'query-string';
import Joi from 'joi-browser';
import { APIAddress } from "constants/config";
import savePaymentMethod from './savePaymentMethod';
import createSubscription from '../payment/addSubscription';

//
// NOTE:
// This is a chained controller with 2 controllers in a row. The backend
// MUST take care of 2 consecutive processes like this...
// but for now, we just cope with what we have...
//
export default function processPayment({ source, email, plan_codename, quantity }) {
  return new Promise((resolve, reject)=>{
    savePaymentMethod({ source, email })
      .then((success)=>{
        createSubscription({ plan_codename, quantity })
          .then((res)=>{
            resolve(res);
          })
          .catch((err)=>{
            reject(err);
          });
      })
      .catch((err)=>{
        reject(err);
      });
  });
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/payment/processPayment.js